import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  statusText: {
    marginBottom: theme.spacing(2),
    '& b': {
      color: theme.palette.colors.black,
    },
  },
  statusContainer: {
    paddingBottom: theme.spacing(3),
    borderBottom: [1, 'dashed', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      paddingBottom: theme.spacing(4),
      borderBottom: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/AccountStatus/useStyles.js